import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Checks if a verification is valid based on verification status and expiry date
 * @param isVerified Boolean indicating if the profile is verified
 * @param expiryDate Optional expiry date string
 * @returns Boolean indicating if the verification is currently valid
 */
export function isValidVerification(
  isVerified: boolean | null,
  expiryDate: string | null,
): boolean {
  // If not verified, verification is invalid
  if (!isVerified) return false;

  // If verified but no expiry date, consider as valid (permanent verification)
  if (!expiryDate) return true;

  // Check if the expiry date is in the future
  const expiry = new Date(expiryDate);
  const now = new Date();

  console.log(
    `Checking verification: isVerified=${isVerified}, expiry=${expiryDate}, valid=${expiry > now}`,
  );

  return expiry > now;
}
